export default "__VITE_ASSET__DB660Tk2__"